import React from 'react';
import c from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import PublishedTime from '../../_partials/PublishedTime';
import UserAvatar from '../../../User/Avatar/UserAvatar';
import UserLink from '../../../User/Link/UserLink';
import s from './UserInfoBlock.scss';
const UserInfoBlock = ({ user, publishedTime })=>{
    const redesigned_money_banners = useFlag('redesigned_money_banners');
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        size: 32,
        user: user,
        className: s['author-avatar']
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['author-username']
    }, /*#__PURE__*/ React.createElement(UserLink, {
        user: user,
        className: s['author-userlink']
    }), publishedTime && /*#__PURE__*/ React.createElement(PublishedTime, {
        className: c(redesigned_money_banners && s['time-updated']),
        publishedTime: publishedTime,
        withoutText: true
    })));
};
UserInfoBlock.displayName = 'UserInfoBlock';
export default UserInfoBlock;
